import { Pagination, Table, Tag, notification, Image } from "antd";
import API from "../../config/API";
import { DELETE } from "../../utils/apiCalls";
import { BiSolidEditAlt } from "react-icons/bi";
import { ColumnsType } from "antd/es/table";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaBoltLightning } from "react-icons/fa6";
function DataTable(props: any) {
  const [Notifications, contextHolder] = notification.useNotification();
  const navigate = useNavigate();
  const Settings = useSelector((state: any) => state.Settings.Settings);

  const itemDeleteHandler = async (item: any) => {
    const url = API.PRODUCTS_DELETE + item?._id;
    try {
      const response: any = await DELETE(url);
      if (response.status) {
        Notifications["success"]({
          message: "Success",
          description: response.message,
        });
        props?.getProducts(props?.page);
      } else {
        Notifications["error"]({
          message: "Failed to Delete",
          description: response.message,
        });
      }
    } catch (err: any) {
      Notifications["error"]({
        message: "Failed to Delete",
        description: err.message,
      });
    }
  };
  const columns: ColumnsType<any> = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (item: any) => <Image width={40} height={30} src={item} />,
      width: 60,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Quantity",
      dataIndex: "unit",
      key: "unit",
      responsive: ["md"],
      render: (item: any) => (
        <span>
          {item == 0 ? (
            <span className="text-danger">{"Out of stock"}</span>
          ) : (
            <span>{item}</span>
          )}
        </span>
      ),
    },
    {
      title: "Price",
      dataIndex: "grandTotal",
      key: "price",
      render: (item: number) => (
        <span>
          {Number(item)?.toFixed(2)} {Settings?.currency ?? ""}
        </span>
      ),
      responsive: ["md"],
    },
    {
      title: "Method",
      dataIndex: "price_method",
      key: "price_method",
      render: (item: any) => (
        <Tag color={item === "Live" ? "red" : "blue"}>{item}</Tag>
      ),
      responsive: ["md"],
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 100,
      render: (item: boolean) =>
        item == true ? (
          <Tag color="green" bordered={false}>
            Active
          </Tag>
        ) : item == false ? (
          <Tag color="orange" bordered={false}>
            Inactive
          </Tag>
        ) : (
          <Tag color="green" bordered={false}>
            Unknown
          </Tag>
        ),
    },

    {
      title: "Actions",
      key: "actions",
      width: 80,
      render: (_text: any, _record: any) => (
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <BiSolidEditAlt
            cursor="pointer"
            size={20}
            color={API.COLOR}
            onClick={() => {
              navigate(`/auth/edit-products/${_record?._id}`);
            }}
          />
          <FaBoltLightning
            size={20}
            color={API.COLOR}
            cursor="pointer"
            onClick={() => {
              props?.setQuickModal();
              props?.setSelected(_record);
            }}
          />
        </div>
      ),
    },
  ];
  return (
    <div>
      {contextHolder}
      <Table
        size="small"
        dataSource={props?.data?.length ? props.data : []}
        columns={columns}
        pagination={false}
        bordered={false}
      />
      <div className="d-flex justify-content-center mt-3 mb-5">
        <Pagination
          current={props?.page || 1}
          pageSize={props?.take || 10}
          total={props?.meta?.itemCount || 0}
          defaultCurrent={1}
          responsive={true}
          defaultPageSize={props?.pageSize || 10}
          disabled={false}
          hideOnSinglePage={true}
          onChange={(current: any, size: any) => {
            props?.changePage(current, size);
          }}
          pageSizeOptions={["10", "20", "50"]}
        />
      </div>
    </div>
  );
}

export default DataTable;
